import type { CustomerOrderOfferViewPriceRecalculationStatus } from "src/api/generated/erp/db/types/enums/customerOrderOfferViewPriceRecalculationStatus.ts";
import type { CustomerOrderViewPriceRecalculationStatus } from "src/api/generated/erp/db/types/enums/customerOrderViewPriceRecalculationStatus.ts";
import type { CustomerPriceGroupPricingMethod } from "src/api/generated/io/aavo/applications/db/erp/types/customerPriceGroupPricingMethod.ts";

export type PriceRecalculationStatus =
	| CustomerOrderOfferViewPriceRecalculationStatus
	| CustomerOrderViewPriceRecalculationStatus;

export function shouldShowPriceRecalculationActions(
	pricingMethod: CustomerPriceGroupPricingMethod,
	status: PriceRecalculationStatus,
) {
	return pricingMethod === "PROFIT_MARGIN" || status !== "UP_TO_DATE";
}
